import { render, staticRenderFns } from "./SinglechoiceModule.vue?vue&type=template&id=26dd249f&scoped=true"
import script from "./SinglechoiceModule.vue?vue&type=script&lang=js"
export * from "./SinglechoiceModule.vue?vue&type=script&lang=js"
import style0 from "./SinglechoiceModule.vue?vue&type=style&index=0&id=26dd249f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd249f",
  null
  
)

export default component.exports